import { render, staticRenderFns } from "./MeasurementsList.vue?vue&type=template&id=6753e45e&scoped=true&"
import script from "./MeasurementsList.vue?vue&type=script&lang=js&"
export * from "./MeasurementsList.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementsList.vue?vue&type=style&index=0&id=6753e45e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6753e45e",
  null
  
)

export default component.exports